<template>
    <div id="vehicle">
        <h3 class="card-title">{{lineName}}</h3>
        <div class="seat_list">
            <div class="seat_item" v-for="(item, index) in tableData" :key="index">
                <div>
                    <h4>{{ item.vehicleSeat }}座车值班车辆</h4>
                    <el-table :data="item.vehicles" style="width: 100%; height: calc(100vh - 340px);" border>
                        <el-table-column prop="name" label="车辆号牌">
                            <template slot-scope="{ row }">
                                <span 
                                  v-if="row.licenseNo"
                                  :style="getPlateStyle(row.licenseNo)"
                                >{{ formatPlateNumber(row.licenseNo) }}</span>
                                <span v-else>-</span>
                                <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="driverName" label="值班司机" />
                        <el-table-column prop="status" label="操作" width="60">
                            <template slot-scope="{ row }">
                                <el-button type="text" style="color: #F56C6C;" size="mini"
                                    @click="handleDelete(row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-button style="width: 100%; margin-top: 10px;" size="small"
                        @click="handleAdd(item)">添加</el-button>
                </div>
            </div>
        </div>
        <el-dialog :visible="dialogVisible" title="添加车辆" width="800px" :before-close="handleClose"
            :destroy-on-close="true" :close-on-click-modal="false">
            <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" :refreshShow="false" :hasChecked="true" :checkedList="checkedList"
                :maxHeight="350" :loadmoreSwitch="true">
                <template slot-scope="{ item, row }">
                    <template v-if="item.prop === 'checked'">
                        <el-checkbox v-model="row.checked" @change="handleChecked($event, row)"
                            :disabled="currentVehicles.some(item => item.driverId === row.driverId)"></el-checkbox>
                    </template>
                    <template v-else>
                        <span>{{ row[item.prop] || '-' }}</span>
                    </template>
                </template>
            </custom-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="handleConfirm" :loading="addLoading">添加车辆</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: this.$route.query.id,
            organizationId: this.$route.query.organizationId,
            lineName: this.$route.query.lineName,
            dialogVisible: false,
            tableData: [],
            addLoading: false,
            customOptions: {
                url: '/api/v1/manage/driver/vehicle',
                method: 'post',
                params: {
                    page: 1, // 页数
                    size: 10, // 每页条数
                },
                search: [
                    { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
                    { type: "input", field: "driverName", name: "值班司机", value: "" },
                ],
            },
            columns: [
                { prop: "organizationName", label: "机构名称", minWidth: 120 },
                { prop: "licenseNo", label: "车辆号牌", minWidth: 120 },
                { prop: "vehicleModel", label: "车辆型号", minWidth: 120 },
                { prop: "vehicleSeat", label: "座位数", minWidth: 120 },
                { prop: "driverName", label: "值班司机", minWidth: 120 },
                { prop: "checked", label: "选择", minWidth: 120 },
            ],
            currentVehicles: [],
            checkedList: []
        };
    },
    async created() {
        this.getInfo();
    },
    methods: {
        handleChecked(event, row) {
            if (event) {
                this.checkedList.push(row)
            } else {
                this.checkedList = this.checkedList.filter(item => item.driverId !== row.driverId)
            }
        },
        async getInfo() {
            let { code, data } = await this.$axios.get(`/api/v1/manage/travelLine/vehicle`, {
                lineId: this.id
            });
            if (code === 1) {
                this.tableData = data;
            }
        },
        handleAdd(item) {
            this.currentVehicles = item.vehicles;
            this.dialogVisible = true;
            this.customOptions.params.page = 1;
            this.customOptions.params.vehicleSeat = item.vehicleSeat;
            this.customOptions.params.organizationId = this.organizationId;
            this.$nextTick(() => {
                this.$refs.customTable.listFn()
            })
        },
        handleClose() {
            this.dialogVisible = false;
            this.checkedList = [];
        },
        async handleConfirm() {
            let url = "/api/v1/manage/travelLine/vehicle"
            let checkList = this.$refs.customTable.table.content.filter(item => item.checked)
            if (checkList.length === 0) {
                this.$message.warning('请选择值班车辆')
                return
            }
            this.addLoading = true;
            let params = {
                lineId: this.id,
                vehicles: JSON.stringify(checkList)
            }
            let { code } = await this.$axios.post(url, params)
            if (code === 1) {
                this.$message.success('添加成功');
                this.handleClose();
                this.getInfo();
            }
            this.addLoading = false;
        },
        async handleDelete(row) {
            this.$confirm('是否删除当前值班车辆？', '删除值班车辆', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let url = "/api/v1/manage/travelLine/vehicle"
                let params = {
                    id: row.id
                }
                let { code } = await this.$axios.delete(url, params)
                if (code === 1) {
                    this.$message.success('删除成功');
                    this.getInfo();
                }
            }).catch(() => {

            });
        }
    }
};
</script>
<style lang="less" scoped>
#vehicle {
    .card-title {
        margin-bottom: 16px;
    }
}

.seat_list {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 10px;

    .seat_item {
        width: 32%;
        flex-shrink: 0;

        h4 {
            margin-bottom: 10px;
        }
    }
}
</style>